import { OnInit, Component, HostListener } from "@angular/core";
import { Router } from "@angular/router";

import { NzMessageService, NzTreeHigherOrderServiceToken } from "ng-zorro-antd";
import { HttpErrorResponse } from "@angular/common/http";

import {
  GlobalComponent,
  Result,
  Rfid,
  TimeTable,
} from "../../environments/global";
import { THIS_EXPR } from "@angular/compiler/src/output/output_ast";

@Component({
  selector: "app-data",
  templateUrl: "utente.component.html",
  styleUrls: ["utente.component.scss"],
})
export class UtenteComponent implements OnInit {
  code: string = "";
  isLoading: boolean = true;
  rfid: string = "";
  showIngresso = false;
  showUscita = false;
  totAllHrs = 0;

  // ################################################
  // CLASS: CONSTRUCTOR
  public constructor(
    private router: Router,
    public g: GlobalComponent,
    private message: NzMessageService
  ) {
    // ##################### DEBUG
    this.code = "99999";
    this.loginRfid(false);
    // ###########################
  }
  // ################################################
  // CLASS: ON INIT
  ngOnInit() {
    this.g.trackTitle =
      '<i nz-icon nzType="lock"></i> Inserire il codice di accesso';
  }

  @HostListener("document:keydown", ["$event"])
  handleKeyboardEvent(event: KeyboardEvent) {
    // AVOIT OVERLAPPING REGISTRATION
    if (this.showIngresso || this.showUscita) {
      return;
    }
    // console.log(event.key);

    if (event.key === "Enter") {
      this.loginRfid();
    } else if (event.key === "Escape") {
      this.loginRfid(false);
    } else if (event.key === "Backspace") {
      if (this.rfid.length > 0) {
        this.rfid = this.rfid.substring(0, this.rfid.length - 1);
      }
    } else {
      const key: string = event.key.replace(/[^0-9]/g, "");
      this.rfid += key;
    }
  }

  public addNumber(num: string) {
    if (this.code.length < 5) {
      this.code += num;
    }
  }

  public delNumber() {
    if (this.code.length > 0) {
      this.code = this.code.substring(0, this.code.length - 1);
    }
  }

  loginUtente() {
    this.g.loginUtente(this.code, this.rfid).subscribe(
      (res: Result) => {
        this.process(res);
        // if (res.error === false) {
        //     this.message.success('Codice accettato', { nzDuration: 2000 });
        //     this.isLoading = true;
        //     this.g.userData = res.data;

        //     const query: string = 'SELECT * from chk_orders WHERE `company`="' + this.g.userData.company + '" and `status` = true ORDER BY `code` DESC';
        //     this.g.mysql(query)
        //         .subscribe((resOrders: Result) => {
        //             this.isLoading = false;
        //             this.g.userData.ordini = resOrders.data;
        //             this.router.navigateByUrl('/track/(trackContent:ordine)');
        //         }, (error: HttpErrorResponse) => {
        //             this.isLoading = false;
        //             this.message.error('Si è vericato un errore non previsto:<br>' + error.statusText, { nzDuration: 5000 });
        //         });
        // } else {
        //     this.message.warning(res.message, { nzDuration: 5000 });
        //     this.code = '';
        //     this.rfid = '';
        // }
      },
      (error: HttpErrorResponse) => {
        this.code = "";
        this.rfid = "";
        this.message.warning(
          'Si è vericato un errore non previsto:<br>"' + error.statusText + '"'
        );
      }
    );
  }

  loginRfid(bUpdate: boolean = true) {
    this.g.loginUtente(this.code, this.rfid).subscribe(
      (res: Result) => {
        if (bUpdate) {
          this.process(res);
        } else {
          this.noProcess(res);
        }
      },
      (error: HttpErrorResponse) => {
        this.code = "";
        this.rfid = "";
        this.message.warning(
          'Si è vericato un errore non previsto:<br>"' + error.statusText + '"'
        );
      }
    );
  }
  process(res: Result) {
    if (res.error === false) {
      this.message.success("Codice accettato", { nzDuration: 1000 });
      this.isLoading = true;

      this.g.userData = res.data;
      const timeStamp = new Date().getTime();

      let query: string =
        "SELECT * from chk_rfid WHERE `code`=" +
        this.g.userData.code +
        " AND `marked`= 0 ORDER BY `time_enter` DESC";
      this.g.mysql(query).subscribe(
        (resOrders: Result) => {
          this.isLoading = false;
          // tslint:disable-next-line:label-position
          const data: Rfid[] = resOrders.data;

          if (data === null || data.length === 0 || data[0].time_exit !== 0) {
            // ENTRATA
            query =
              "INSERT into chk_rfid (`code`, `time_enter`) VALUES (" +
              '"' +
              this.g.userData.code +
              '",' +
              timeStamp +
              ")";

            this.isLoading = true;
            this.g.mysql(query).subscribe((resQuery: Result) => {
              this.showIngresso = true;
              setTimeout(() => {
                this.showIngresso = false;
              }, 3000);
            });
          } else {
            query =
              "UPDATE chk_rfid SET `time_exit` = " +
              timeStamp +
              " WHERE `code` = " +
              this.g.userData.code +
              " AND " +
              "`time_enter` = " +
              data[0].time_enter;
            this.g.mysql(query).subscribe((resQuery: Result) => {
              // USCITA
              this.showUscita = true;
              data[0].time_exit = timeStamp;
              this.calc(data);
            });
          }
          // localStorage.setItem("webcheck", JSON.stringify(this.g.userData.ordini));
          // this.router.navigateByUrl('/track/(trackContent:ordine)');
        },
        (error: HttpErrorResponse) => {
          this.isLoading = false;
          this.message.error(
            "Si è vericato un errore non previsto:<br>" + error.statusText,
            { nzDuration: 5000 }
          );
        }
      );
      this.code = "";
      this.rfid = "";
    } else {
      this.message.warning(res.message, { nzDuration: 5000 });
      this.code = "";
      this.rfid = "";
    }
  }

  noProcess(res: Result) {
    if (res.error === false) {
      this.message.success("Codice accettato", { nzDuration: 1000 });
      this.isLoading = true;

      this.g.userData = res.data;
      const timeStamp = new Date().getTime();

      const query: string =
        "SELECT * from chk_rfid WHERE `code`=" +
        this.g.userData.code +
        " AND `marked`= 0 ORDER BY `time_enter` DESC";
      // console.log(query);
      this.g.mysql(query).subscribe(
        (resOrders: Result) => {
          this.isLoading = false;
          const data: Rfid[] = resOrders.data;
          this.showUscita = true;
          if (data[0].time_exit <= 0) {
            data[0].time_exit = timeStamp;
          }
          this.calc(data);
        },
        (error: HttpErrorResponse) => {
          this.isLoading = false;
          this.message.error(
            "Si è vericato un errore non previsto:<br>" + error.statusText,
            { nzDuration: 5000 }
          );
        }
      );
      this.code = "";
      this.rfid = "";
    } else {
      this.message.warning(res.message, { nzDuration: 5000 });
      this.code = "";
      this.rfid = "";
    }
  }

  calc(data: Rfid[]) {
    let lastEnter = 0;
    let totHrs = 0;
    let totAllHrsRaw = 0;
    this.totAllHrs = 0;
    this.g.userData.times = [];
    let newEnter: number;
    let t: TimeTable;
    let enters: number[] = [];
    let dtDiff = 0;

    data.forEach((d) => {
      if (d.time_exit !== 0) {
        dtDiff = this.g.diffTimeRaw(d.time_enter, d.time_exit); // diff grezza in ore
      } else {
        dtDiff = 0;
      }
      newEnter = new Date(d.time_enter).setHours(0, 0, 0, 0);
      if (lastEnter !== newEnter) {
        if (totHrs !== 0) {
          t = { time: lastEnter, totH: totHrs, enters: enters };
          this.g.userData.times.push(t);
        }
        enters = [];
        enters.push(d.time_enter);
        lastEnter = newEnter;
        totHrs = dtDiff;
      } else {
        enters.push(d.time_enter);
        totHrs += dtDiff;
      }
      // console.log('DIFF', d.time_enter, d.time_exit, dtDiff);
      totAllHrsRaw += dtDiff;
    });
    if (totHrs !== 0) {
      t = { time: lastEnter, totH: totHrs, enters: enters };
      this.g.userData.times.push(t);
    }
    this.totAllHrs = this.g.roundToHalfDown(totAllHrsRaw);
    // console.log('TOTH', this.totAllHrs);
  }
  continue() {
    this.showUscita = false;
  }
  edit() {
    this.router.navigateByUrl("/track/(trackContent:insert)");
  }
}
